import * as Ably from 'ably';
import { useEffect, useState } from 'react';

import { createDefaultRequestTokenDataHandler } from '../../api';

/**
 * Custom hook to initialize and manage an Ably Realtime client.
 * @function useAblyClient
 * @returns {Ably.Realtime | null} The Ably Realtime client instance or null if not initialized.
 */
export function useAblyClient() {
  const [ablyClient, setAblyClient] = useState<Ably.Realtime | null>(null);

  useEffect(() => {
    const initAbly = async () => {
      try {
        const client = new Ably.Realtime({
          autoConnect: typeof window !== 'undefined',
          authCallback: async (tokenParams, callback) => {
            try {
              const response = await createDefaultRequestTokenDataHandler();
              const tokenRequest = await response.json();
              callback(null, tokenRequest);
            } catch (error) {
              callback(error as Ably.ErrorInfo, null);
            }
          },
        });
        setAblyClient(client);
      } catch (error) {
        console.error('Failed to initialize Ably client:', error);
      }
    };

    initAbly();

    return () => {
      ablyClient?.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ablyClient;
}
